module.exports = __webpack_public_path__ + "img/qrec_scheme-17.7f7d17e9.png";